import "@mdi/font/css/materialdesignicons.css"

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

import de from 'vuetify/lib/locale/de'
import en from 'vuetify/lib/locale/en'

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    //dark: true,
    themes: {
      light: {
        primary: colors.red.darken1,
        secondary: colors.red.lighten4,
        accent: colors.indigo.base
      },
      dark: {
        primary: colors.red.darken1,
        secondary: colors.red.lighten4,
        accent: colors.indigo.base
      },
    },
  },
  lang: {
    locales: { de, en },
    current: 'de',
  },
}

Vue.use(Vuetify);

export default new Vuetify(opts);
